var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Search"}},[_c('b-input-group',{staticClass:"mb-4"},[_c('b-form-input',{attrs:{"value":_vm.search,"placeholder":"Search"},on:{"input":_vm.changeSearch}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }